"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.focusBorderStyles = exports.hoverBorderStyles = exports.defaultInputStyles = exports.focusHoverInsetBorderStyles = exports.focusOnlyInsetStyles = exports.focusOnlyStyles = exports.defaultTransitionStyles = exports.focusHoverSharedStyles = exports.defaultLinkStyles = exports.defaultStyles = exports.focusBoxShadow = exports.hoverBoxShadow = void 0;
/**
 * Shared Focus and Hover states, to be used in multiple components
 */
const styled_components_1 = require("styled-components");
const tokens_1 = require("./tokens");
/* Separate defintions for individual parts */
const defaultBorder = (0, styled_components_1.css) `
    border: none;
    border-radius: ${tokens_1.BORDERS.radius};
`;
exports.hoverBoxShadow = `0 0 0 1px ${tokens_1.COLOURS.greyscale.metal}`;
exports.focusBoxShadow = `0 0 0 1px ${tokens_1.COLOURS.greyscale.metal}, 0 0 0 3px ${tokens_1.COLOURS.greyscale.white},
    0 0 0 5px ${tokens_1.COLOURS.primary.blue[100]}`;
/** Padding is so that curved borders above don't clip the content of the text within the component */
const defaultSpacing = (0, styled_components_1.css) `
    padding: 0 ${tokens_1.SIZES[0.5]};
`;
const defaultTransition = (0, styled_components_1.css) `
    transition-property: background-color, box-shadow, border;
    transition-duration: 0.2s;
    transition-timing-function: ease;
`;
const hoverFocusColour = (0, styled_components_1.css) `
    color: ${tokens_1.COLOURS.primary.blue[130]};
`;
const hoverFocusBackgroundColour = (0, styled_components_1.css) `
    background-color: ${tokens_1.COLOURS.primary.blue[25]};
`;
const hoverFocusIconFill = (0, styled_components_1.css) `
    path {
        fill: ${tokens_1.COLOURS.primary.blue[130]};
    }
`;
const focusStyling = (0, styled_components_1.css) `
    outline: none;
    box-shadow: 0 0 0 2px ${tokens_1.COLOURS.greyscale.white},
        0 0 0 4px ${tokens_1.COLOURS.primary.blue[100]};
`;
const focusStylingInset = (0, styled_components_1.css) `
    outline: none;
    box-shadow: inset 0 0 0 2px ${tokens_1.COLOURS.greyscale.white},
        inset 0 0 0 4px ${tokens_1.COLOURS.primary.blue[100]};
`;
const focusHoverInsetBorderStyling = (0, styled_components_1.css) `
    border-width: 1px;
`;
/**
 * Exported reusable styles
 */
/**
 * Use defaultStyles on a focusable element to reset the border only
 */
exports.defaultStyles = (0, styled_components_1.css) `
    ${defaultBorder}
    ${defaultTransition}
`;
/**
 * Use defaultStyles on a focusable element to reset the border and have relevant spacing
 */
exports.defaultLinkStyles = (0, styled_components_1.css) `
    ${defaultBorder}
    ${defaultSpacing}
    ${defaultTransition}
`;
/**
 * Use focusHoverSharedStyles within a joint focus & hover state block
 * where you want to change the background fill - not suitable for all cases
 * &:active, &:focus, &:focus-visible, &:hover {
        ${focusHoverSharedStyles}
    }
 */
exports.focusHoverSharedStyles = (0, styled_components_1.css) `
    ${hoverFocusColour}
    ${hoverFocusBackgroundColour}
    ${hoverFocusIconFill}
    ${defaultTransition}
`;
/**
 * Use focusOnlyStyles within a focus state block
 * the double selector increases specificity, which overrides
 * a global browser style without needing to use !important
 * &:focus&:focus, &:focus-visible {
        ${focusOnlyStyles}
    }
 */
exports.defaultTransitionStyles = (0, styled_components_1.css) `
    ${defaultTransition}
`;
exports.focusOnlyStyles = (0, styled_components_1.css) `
    ${focusStyling}
`;
exports.focusOnlyInsetStyles = (0, styled_components_1.css) `
    ${focusStylingInset}
`;
exports.focusHoverInsetBorderStyles = (0, styled_components_1.css) `
    ${focusHoverInsetBorderStyling}
`;
/**
 * Use defaultInputStyles on a focusable input element to set border & transition e.g. Input, TextArea
 */
exports.defaultInputStyles = (0, styled_components_1.css) `
    border: ${tokens_1.BORDERS.normal.stone};
    border-radius: ${tokens_1.BORDERS.radius};
    outline: none;
    ${defaultTransition}
`;
/**
 * Use inputHoverStyles to enable hover styles on a focusable element to set border and box shadow styles e.g. Input, TextArea
 */
exports.hoverBorderStyles = (0, styled_components_1.css) `
    border: 1px solid ${tokens_1.COLOURS.greyscale.metal};
    box-shadow: ${exports.hoverBoxShadow};
`;
/**
 * Use inputHoverStyles to enable focus styles on a focusable element to set border and box shadow styles e.g. Input, TextArea
 */
exports.focusBorderStyles = (0, styled_components_1.css) `
    border: 1px solid ${tokens_1.COLOURS.greyscale.metal};
    box-shadow: ${exports.focusBoxShadow};
`;
//# sourceMappingURL=focusHover.js.map